module.exports = __webpack_public_path__ + "img/przelewy24_logo_2022_navy_blue.d2f728c1.svg";